export default __webpack_public_path__ + "static/03.04-6b8f0fd30e950d8be0dac8db6974052e.png";